import React, { useEffect, useState } from "react";

import "./styles/readingProgress.css";

const ReadingProgress = () => {
	const [width, setWidth] = useState(0);

	useEffect(() => {
		const onScroll = () => {
			const el = document.documentElement;
			const scrollTop = el.scrollTop || document.body.scrollTop;
			const height = el.scrollHeight - el.clientHeight;
			const pct = height > 0 ? (scrollTop / height) * 100 : 0;
			setWidth(pct);
		};

		window.addEventListener("scroll", onScroll, { passive: true });
		onScroll();
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	return (
		<div className="reading-progress">
			<div
				className="reading-progress-bar"
				style={{ width: `${width}%` }}
			/>
		</div>
	);
};

export default ReadingProgress;
